<script setup>
import { computed, inject } from "vue";
import { usePage } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";

const route = inject("route");
const { t } = useI18n();
</script>
<template>
  <div class="section-container">
    <div class="relative z-10 flex flex-col justify-center items-start w-full text-left h-full">
      <!-- Title -->
      <h2 class="text-4xl md:text-5xl">{{ $t('Over Zorgblik') }}</h2>
      <div class="mt-5 text-lg md:text-xl">{{ $t('Digitale zorginnovatie') }}</div>
      <div
        class="mt-5 text-lg md:text-xl"
      >{{ $t('Zorgblik levert digitale diensten voor het snel en flexibel inzetten van zorgpersoneel. Onze oplossing is specifiek ontwikkeld voor ziekenhuizen, zorginstellingen en thuiszorgorganisaties die behoefte hebben aan betrouwbare professionals.') }}</div>
    </div>
  </div>
</template>